// Explain the restriction already resolved by the caller; this screen never grants access.
import React from "react";
import { Button } from "@/ds";
import { Icon } from "@/lib";
import { useT } from "../i18n";

export interface DeniedScreenProps {
  onHome?: () => void;
  area?: string;
  reason: "admin" | "owner";
}

export function DeniedScreen({ onHome, area, reason }: DeniedScreenProps) {
  const t = useT();
  const areaLabel = area ?? t("denied.defaultArea");
  return (
    <div className="center-screen">
      <div className="denied">
        <div className="denied__ic"><Icon name="ban" size={28} /></div>
        <h1>{t("denied.title")}</h1>
        <p>{t(`denied.reason.${reason}`, { area: areaLabel })}</p>
        <Button variant="secondary" iconLeft={<Icon name="arrowLeft" size={16} />} onClick={onHome}>{t("denied.toInbox")}</Button>
      </div>
    </div>
  );
}
